// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { parentCategoryList } from '../../helpers/data'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import generateReportQuery from '../../helpers/generateReportQuery'
import { accountPermissions, operationPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt

export default {
  getAccountOfficerList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/AccountOfficer/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountOfficers: async ({ commit }) => {
    try {
      useJwt.setPermission('VIEW_ACCOUNT_OFFICER')
      const response = await axiosIns.get('/accounting/api/AccountOfficer/v1/GetAll')
      const data = await response.data.data
      commit('setAccountOfficer', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  searchAccountOfficerInformation: async (context, { staffID, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/AccountOfficer/v1/Search?staffID=${staffID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performAccountOfficerReassign: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/AccountOfficer/v1/AccountOfficerReassignment', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  unlockAccountOfficerAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/AccountOfficer/v1/UnlinkUser', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTillAccountBalance: async ({ commit }, { userId }) => {
    try {
      if (userId) {
        const response = await axiosIns.get(`/accounting/api/TillAccount/v1/GetBalanceByUserID?UserId=${userId}`)
        const balanceData = response.data
        commit('setTillAccountBalance', balanceData)
        return Promise.resolve(response)
      }
      return Promise.resolve(null)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateAccountOfficerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_ACCOUNT_OFFICER)
      const response = await axiosIns.put('/accounting/api/AccountOfficer/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAccountOfficerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_ACCOUNT_OFFICER)
      const response = await axiosIns.post('/accounting/api/AccountOfficer/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountCategoryList: async (context, {
    search,
    page = 1,
    limit = 10,
    permission = accountPermissions.VIEW_ACCOUNT_CATEGORY,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/AccountCategory/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountGLsCategoryList: async (context, {
    search,
    page = 1,
    limit = 10,
    permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/GLAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateAccountCategoryAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_ACCOUNT_CATEGORY)
      const response = await axiosIns.put('/accounting/api/AccountCategory/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAccountCategoryAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_ACCOUNT_CATEGORY)
      const response = await axiosIns.post('/accounting/api/AccountCategory/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanFeeList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/LoanFee/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateLoanFeeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_LOAN_FEE)
      const response = await axiosIns.put('/accounting/api/LoanFee/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createLoanFeeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_LOAN_FEE)
      const response = await axiosIns.post('/accounting/api/LoanFee/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCAMFeeList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/CotFee/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllCOTFee: async () => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_COT_FEE)
      const response = await axiosIns.get('/accounting/api/CotFee/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCAMFeeById: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CotFee/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCAMFeeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_COT_FEE)
      const response = await axiosIns.put('/accounting/api/CotFee/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCAMFeeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_COT_FEE)
      const response = await axiosIns.post('/accounting/api/CotFee/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOverdraftFeeList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/OverdraftFee/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOverdraftFee: async (context, id) => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_OVERDRAFT_FEE)
      const response = await axiosIns.get(`/accounting/api/OverdraftFee/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOverdraftFeeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_OVERDRAFT_FEE)
      const response = await axiosIns.put('/accounting/api/OverdraftFee/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createOverdraftFeeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_OVERDRAFT_FEE)
      const response = await axiosIns.post('/accounting/api/OverdraftFee/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOverdraft: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/AccountOverdraft/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOverdraftList: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/AccountOverdraft/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(accountPermissions.VIEW_OVERDRAFT)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOverdraftAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_OVERDRAFT)
      const response = await axiosIns.put('/accounting/api/AccountOverdraft/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createOverdraftAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_OVERDRAFT)
      const response = await axiosIns.post('/accounting/api/AccountOverdraft/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInterestList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/Interest/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInterestById: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/Interest/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateInterestAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_INTEREST)
      const response = await axiosIns.put('/accounting/api/Interest/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createInterestAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_INTEREST)
      const response = await axiosIns.post('/accounting/api/Interest/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getChargeList: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/Charge/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(accountPermissions.VIEW_CHARGE)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateChargeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_CHARGE)
      const response = await axiosIns.put('/accounting/api/Charge/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createChargeAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_CHARGE)
      const response = await axiosIns.post('/accounting/api/Charge/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGeneralLedgerList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/GLAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGeneralLedgerByParentCategory: async (context, { parentCategory, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/GLAccount/v1/Search?ParentCategory=${parentCategory}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateGeneralLedgerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_GENERAL_LEDGER)
      const response = await axiosIns.put('/accounting/api/GLAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createGeneralLedgerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_GENERAL_LEDGER)
      const response = await axiosIns.post('/accounting/api/GLAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getCustomerAccountList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/CustomerAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCustomerAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_SAVING_CURRENT_ACCOUNT)
      const response = await axiosIns.put('/accounting/api/CustomerAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCustomerAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_SAVING_CURRENT_ACCOUNT)
      const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createVirtualAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_VIRTUAL_ACCOUNT)
      const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/CreateVirtualAccount', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerAccountAction: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerAccount/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountSignatoriesAction: async (context, { permission, accountNumber }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerAccount/v1/GetAccountSignatories?accountNumber=${accountNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountRefereesAction: async (context, { permission, accountNumber }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerAccount/v1/GetAccountReferees?accountNumber=${accountNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountOfficerByStaffID: async (context, { permission, staffID }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/AccountOfficer/v1/GetByStaffId?staffId=${staffID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountsByCustomerIDAction: async (context, { permission, customerID }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/GetByCustomerID?customerID=${customerID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  toggleCustomerAccountStatus: async (context, {
    permission,
    name,
    status,
    accountNumber,
    reason,
    initiatedBy,
    route,
  }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/accounting/api/CustomerAccount/v1/${route}`, {
        name, status, accountNumber, reason, initiatedBy,
      })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLienList: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/AccountLien/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(accountPermissions.VIEW_LIEN)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateLienAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_LIEN)
      const response = await axiosIns.put('/accounting/api/AccountLien/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  createLienAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_LIEN)
      const response = await axiosIns.post('/accounting/api/AccountLien/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getCustomerList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/CustomerInformation/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGroupCustomerList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/CustomerInformation/v1/SearchGroupCustomers',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateIndividualCustomerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_INDIVIDUAL_CUSTOMER)
      const response = await axiosIns.put('/accounting/api/CustomerInformation/v1/Individual/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createIndividualCustomerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_INDIVIDUAL_CUSTOMER)
      const response = await axiosIns.post('/accounting/api/CustomerInformation/v1/Individual/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getIndividualCustomerById: async (context, id) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_INDIVIDUAL_CUSTOMER)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/Individual?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  uploadDocumentImagesAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/DocumentManagement/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  deleteDocumentsUploadAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/DocumentManagement/v1/Delete', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getGroupMembersByGroupId: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/Group/GetMembers?GroupCustomerID=${formData.groupCustomerID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGroupLendingMembersByGroupId: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/Group/GetConnections?GroupCustomerID=${formData.groupCustomerID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateGroupCustomerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_GROUP_CUSTOMER)
      const response = await axiosIns.put('/accounting/api/CustomerInformation/v1/Group/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createGroupCustomerAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_GROUP_CUSTOMER)
      const response = await axiosIns.post('/accounting/api/CustomerInformation/v1/Group/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomer: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/GetbyID?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  searchCustomerAccountAction: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/CustomerAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProductList: async () => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_LOAN_PRODUCT)
      const response = await axiosIns.get('/accounting/api/Product/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProduct: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      // useJwt.setPermission('VIEW_LOAN_PRODUCT')
      const response = await axiosIns.get(`/accounting/api/Product/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCASAProductAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_SAVING_CURRENT_PRODUCT)
      const response = await axiosIns.put('/accounting/api/Product/v1/UpdateSavingsProduct', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  createCASAProductAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_SAVING_CURRENT_PRODUCT)
      const response = await axiosIns.post('/accounting/api/Product/v1/CreateSavingsProduct', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getPenaltiesList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/Penalty/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updatePenaltyAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_PENALTY)
      const response = await axiosIns.put('/accounting/api/Penalty/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createPenaltyAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_PENALTY)
      const response = await axiosIns.post('/accounting/api/Penalty/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateLoanProductAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_LOAN_PRODUCT)
      const response = await axiosIns.put('/accounting/api/Product/v1/UpdateLoanProduct', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createLoanProductAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_LOAN_PRODUCT)
      const response = await axiosIns.post('/accounting/api/Product/v1/CreateLoanProduct', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanAccountList: async (context, {
    search, page = 1, limit = 10, permission = accountPermissions.VIEW_LOAN_ACCOUNT,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/LoanAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanAccount: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/LoanAccount/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  searchCustomerInformationAction: async (context, { customerID, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/GetByCustomerID?customerID=${customerID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountDetailsByCustomerID: async (context, { customerID, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/accounting/api/CustomerAccount/v1/GetAccountsByCustomerID?customerId=${customerID}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performCustomerRelinkAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/CustomerInformation/v1/Relink', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  revokeLoan: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/LoanAccount/v1/Revoke', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  repayLoan: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/Repay', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  restructureLoan: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/Restructure', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  refinanceLoan: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/Refinance', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateLoanAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_LOAN_ACCOUNT)
      const response = await axiosIns.put('/accounting/api/LoanAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  createLoanAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_LOAN_ACCOUNT)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  disburseLoan: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.DISBURSE_LOAN)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/Disburse', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getComputedInterest: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/ComputeInterest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getPaymentSchedule: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/GeneratePaymentSchedules', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateRepaymentSchedules: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/LoanScheduleEdit', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getFdAccountList: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/FixedDepositAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFixedDepositById: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/FixedDepositAccount/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadFixedDepositCertificate: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/FixedDepositAccount/v1/GetCertificate?accountNumber=${accountNumber}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createFdAccountAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/FixedDepositAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFdAccountAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/FixedDepositAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFdAccountsById: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/FixedDepositAccount/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  disburseFixedDeposit: async (context, data) => {
    try {
      const response = await axiosIns.put('/accounting/api/FixedDepositAccount/v1/Disburse', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  generateMandateRuleAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/GenerateMandateRule', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // Account category
  getLevelThreeList: async (context, { level1, accountCategoryLevel }) => {
    try {
      const response = await axiosIns.get(`/accounting/api/AccountCategory/v1/GetByLevel?level1=${level1}&accountCategoryLevel=${accountCategoryLevel}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLevelTwoCategoryList: async ({ commit, dispatch }, value) => {
    const response = await axiosIns.get(`/accounting/api/AccountCategory/v1/Search?ParentCategory=${value}&Level=2`)
    const data = await response.data.data
    const parentCategory = parentCategoryList.find(item => item.label === value)
    dispatch('getIFRSCategoryList', parentCategory.code)
    commit('setLevelTwoCategory', data)
    return Promise.resolve(response)
  },
  getLevelThreeCategoryList: async ({ commit }, value) => {
    const response = await axiosIns.get(`/accounting/api/AccountCategory/v1/Search?ParentCode=${value}`)
    const { data } = response.data
    commit('setLevelThreeCategory', data)
    return Promise.resolve(response)
  },
  getCategoryList: async () => {
    try {
      const response = await axiosIns.get('/accounting/api/AccountCategory/v1/Search?Level=3')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProducts: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/Product/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProductByTypes: async (context, { type1, type2, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/Product/v1/GetProductsByTypesAsync?types=${type1}&types=${type2}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllCurrenciesAction: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/Currency/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCASABalanceAction: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerAccount/v1/ViewCASAbalance?accountNumber=${accountNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getByAccountNumber: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerAccount/v1/GetByAccountNumber?accountNumber=${accountNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountCategoryByCode: async (context, code) => {
    try {
      const response = await axiosIns.get(`/accounting/api/GLAccount/v1/Search?AccountCategoryCode=${code}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateStatus: async (context, {
    routeName, statusValues, actionType, permission,
  }) => {
    try {
      let route
      if (actionType.toLowerCase() === 'active') {
        route = 'Activate'
      } else if (actionType.toLowerCase() === 'inactive') {
        route = 'Deactivate'
      } else {
        route = 'Disable'
      }
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/accounting/api/${routeName}/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // GL Accounts
  getIncomeGLAccount: async ({ commit }, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/CotFee/v1/GetIncomeGLs')
      const data = await response.data.data
      commit('setIncomeGLAccount', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getIncomeGLByParentCategory: async ({ commit }, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/GLAccount/v1/Search?ParentCategory=4')
      const { data } = response.data
      commit('setIncomeGLByParentCategory', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getStationaryAccount: async ({ commit }, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/GLAccount/v1/Search?AccountCategoryCode=10639000')
      const { data } = response.data
      commit('setStationaryAccount', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getIFRSCategoryList: async ({ commit }, value) => {
    try {
      const response = await axiosIns.get(`/accounting/api/GLAccount/v1/GetIFRSMapping?parentCategory=${value}`)
      const data = await response.data.data
      commit('setIFRSCategory', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLAccountBalance: async (context, id) => {
    try {
      const response = await axiosIns.get(`/accounting/api/GLAccount/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllGLAccount: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/GLAccount/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGlAccountNameByCode: async (context, { code, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/GLAccount/v1/Search?Code=${code}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLAccountsByAccountTypeList: async (context, { accountType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/OtherBusinessAutomation/v1/GetGLAccountsByAccountType?accountType=${accountType}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLAccountByCode: async (context, { accountType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/GLAccount/v1/Search?Code=${accountType}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLAccountsByList: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/GLAccount/v1/GetGLAccountsByAccountType?accountType=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountTypesList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get('/accounting/api/BusinessAutomation/v1/GetAccountTypes')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerImagesByCustomerID: async (context, { permission, customerID }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/GetCustomerImagesByCustomerID?customerID=${customerID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerInformationByCustomerID: async (context, { permission, customerID }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/GetByCustomerID?customerID=${customerID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanAgreementLetterV1: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/LoanAccount/v1/GetLoanAgreementV1?accountNumber=${accountNumber}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanAgreementLetterV2: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/LoanAccount/v1/GetLoanAgreement?accountNumber=${accountNumber}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerInformation: async (context, { permission, customerID }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/GetByCustomerID?customerID=${customerID}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountSignatories: async (context, { permission, accountNumber }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CustomerInformation/v1/GetByCustomerID?accountNumber=${accountNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createFDProductAction: async (context, formData) => {
    try {
      useJwt.setPermission('CREATE_FIXED_DEPOSIT_PRODUCT')
      const response = await axiosIns.post('/accounting/api/Product/v1/CreateFixedDepositProduct', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFDProductAction: async (context, formData) => {
    try {
      useJwt.setPermission('MODIFY_FIXED_DEPOSIT_PRODUCT')
      const response = await axiosIns.put('/accounting/api/Product/v1/UpdateFixedDepositProduct', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFixedAssetRegisterList: async (context, { search, page, limit = 10 }) => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_FIXED_ASSET)
      const url = generateSearchQuery({
        filter: search,
        url: '/accounting/api/FixedAssetRegister/v1/Search',
        currentPage: page,
        perPage: limit,
      })
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createFixedAssetRegisterAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_FIXED_ASSET)
      const response = await axiosIns.post('/accounting/api/FixedAssetRegister/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFixedAssetRegisterAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_FIXED_ASSET)
      const response = await axiosIns.put('/accounting/api/FixedAssetRegister/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getfixedAssetParentGeneralLedger: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/FixedAssetRegister/v1/GetFixedAssetParentGLs',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getpaymentSourceGeneralLedger: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/FixedAssetRegister/v1/GetPaymentSourceGLs')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  liquidateAssetRegister: async (context, { permission, id, initiatedBy }) => {
    const data = { id, initiatedBy }
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/FixedAssetRegister/v1/Liquidate', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getprepaymentAmortizationList: async (context, { search, page, limit = 10 }) => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_PREPAYMENT_AMORTIZATION)
      const url = generateSearchQuery({
        filter: search,
        url: '/accounting/api/PrepaymentAmortization/v1/Search',
        currentPage: page,
        perPage: limit,
      })
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createPrepaymentAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.CREATE_PREPAYMENT_AMORTIZATION)
      const response = await axiosIns.post('/accounting/api/PrepaymentAmortization/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updatePrepaymentAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.MODIFY_PREPAYMENT_AMORTIZATION)
      const response = await axiosIns.put('/accounting/api/PrepaymentAmortization/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPrepaymentGeneralLedger: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/PrepaymentAmortization/v1/GetPrepaymentGLs')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAmortiztionGeneralLedger: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/PrepaymentAmortization/v1/GetAmortizationExpenseGLs')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFDAccountInformation: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/FixedDepositAccount/v1/GetByAccountNumber?accountNumber=${accountNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  releaseSecurityDeposit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/LoanAccount/v1/ReleaseSecurityDeposit', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPlacementSourceGeneralLedger: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/Placement/v1/GetSourceGLs')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPlacementInvestmentGeneralLedger: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/Placement/v1/GetInvestmentGLs')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPlacementInterestReceivableGLs: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/Placement/v1/GetInterestReceivableGLs')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPlacementInterestIncomeGLs: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/Placement/v1/GetInterestIncomeGLs')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPlacementsList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/Placement/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProvisionedLoans: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/LoanProvisioning/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(accountPermissions.VIEW_LOAN_PROVISIONING)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProvisionedOverdraft: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/OverdraftProvisioning/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(accountPermissions.VIEW_OVERDRAFT_PROVISIONING)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updatePlacementAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.UPDATE_PLACEMENT)
      const response = await axiosIns.put('/accounting/api/Placement/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createPlacementAction: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.ADD_PLACEMENT)
      const response = await axiosIns.post('/accounting/api/Placement/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProvisionedLoanSummary: async (context, { provisionDate }) => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_LOAN_PROVISIONING)
      const response = await axiosIns.get(`/accounting/api/LoanProvisioning/v1/ShowSummary?ProvisionDate=${provisionDate}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postLoanProvision: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_LOAN_PROVISIONING)
      const response = await axiosIns.post('/accounting/api/LoanProvisioning/v1/Post', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  reevaluateProvisionAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanProvisioning/v1/Reevaluate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProvisionedOverdraftSummary: async (context, { provisionDate }) => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_OVERDRAFT_PROVISIONING)
      const response = await axiosIns.get(`/accounting/api/OverdraftProvisioning/v1/ShowSummary?ProvisionDate=${provisionDate}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postOverdraftProvision: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.VIEW_OVERDRAFT_PROVISIONING)
      const response = await axiosIns.post('/accounting/api/OverdraftProvisioning/v1/Post', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // getAccountsByAccountNumbers: async (context, { formData, permission }) => {
  //   const searchParams = new URLSearchParams(formData)
  //   try {
  //     useJwt.setPermission(permission)
  //     const response = await axiosIns.get(`accounting/api/CustomerAccount/v1/GetAccountsByAccountNumbers?${searchParams.toString()}`)
  //     return Promise.resolve(response)
  //   } catch (error) {
  //     return Promise.reject(error)
  //   }
  // },

  getDocumentFilesAction: async (context, { referenceNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/DocumentManagement/v1/Search?ReferenceNumber=${referenceNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAbridgeLoanAccountAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/LoanAccount/v1/AbridgedLoan', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSalaryHistory: async (context, { formData, permission }) => {
    const searchParams = new URLSearchParams(formData)
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/ThirdPartyLoanCollection/v1/GetSalaryHistory?${searchParams.toString()}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  fetchMandateHistory: async (context, { formData, permission }) => {
    const searchParams = new URLSearchParams(formData)
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/ThirdPartyLoanCollection/v1/GetMandateHistory?${searchParams.toString()}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  remitaLoanDisbursementAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/ThirdPartyLoanCollection/v1/RetryLoanDisbursementNotification', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSalaryBankList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('accounting/api/ThirdPartyLoanCollection/v1/GetBanks')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRemitaCollectionsReport: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'ThirdPartyLoanCollection/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  liquidatePlacementAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/Placement/v1/Liquidate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  disbursePlacement: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/Placement/v1/Disburse', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  accountMemoCreateAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/Memo/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  accountMemoUpdateAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/Memo/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountMemoAction: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'Memo/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getComputeInterestAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('accounting/api/FixedDepositAccount/v1/ComputeInterest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getStandingOrderList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'StandingOrder/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createStandingOrderAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/StandingOrder/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateStandingOrderAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/StandingOrder/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createBackgroundInformation: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/StandingOrder/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateBackgroundInformation: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/StandingOrder/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPfiOnboardingList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'PartnerFinancialInstitution/v1/SearchSubmittedApplications',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPFIOnboardingInitialize: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/InitiatePFIOnboarding', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createPfiOnboardingAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/SaveProgress', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createPfiOnboardingAllAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/PFISubmit', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updatePfiOnboardingAction: async (context, { formUpdate, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/PartnerFinancialInstitution/v1/Modify', formUpdate)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  fetchPfiOnboardingDetails: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/PartnerFinancialInstitution/v1/ViewSubmittedApplication?Id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPfiOnboardingDraftList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'PartnerFinancialInstitution/v1/SearchApplicationsInProgress',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadPfiOnboarding: async (context, {
    search, page = 1, limit = 20, fileExportFormat, permission,
  }) => {
    const url = generateReportQuery({
      filter: search,
      url: 'PartnerFinancialInstitution/v1/ExportApplicationsInProgress',
      currentPage: page,
      perPage: limit,
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getKYCInformation: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'PartnerFinancialInstitution/v1/SearchDirectors',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  deletePartnerDocumentAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/DeletePartnerDocument', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  deleteKYCDirectorAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/DeleteDirector', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // deletePartnerDocumentAction: async (context, { id, permission }) => {
  //   try {
  //     useJwt.setPermission(permission)
  //     const response = await axiosIns.delete(
  //       `/accounting/api/PartnerFinancialInstitution/v1/DeletePartnerDocument?id=${id}`,
  //     )
  //     return Promise.resolve(response)
  //   } catch (error) {
  //     return Promise.reject(error)
  //   }
  // },
  createKYCInstitutionDocumentation: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/UploadOrUpdatePartnerDocument', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createKYCDirectorAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/AddDirectors', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateKYCDirectorAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/UpdateDirectors', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAllKYCInformation: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/SubmitDirectors', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  uploadDocumentFilesAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/UploadOrUpdatePartnerDocument', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSupportingDocuments: async (context, { partnerCode, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/PartnerFinancialInstitution/v1/SearchSupportingDocument?PartnerCode=${partnerCode}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  uploadSupportingDocumentImages: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/CreateSupportingDocument', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPFIDetailsAction: async (context, { institutionEmail, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/PartnerFinancialInstitution/v1/SearchSubmittedApplications?InstitutionEmail=${institutionEmail}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPfiByPartnerCode: async (context, { partnerCode, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/PartnerFinancialInstitution/v1/SearchSubmittedApplications?PartnerCode=${partnerCode}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllPartnerCodes: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('accounting/api/PartnerFinancialInstitution/v1/SearchSubmittedApplications')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getcollateralManagementList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CollateralInformation/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCollateralAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/CollateralInformation/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCollateralAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/CollateralInformation/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCollateralDocumentById: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CollateralInformation/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAvailableCollaterals: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/accounting/api/CollateralInformation/v1/Search')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCollateralDetails: async (context, { referenceCode, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/CollateralInformation/v1/Search?ReferenceCode=${referenceCode}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  saveProgressPfiLendingAccount: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/ExternalLoanAccount/v1/SavePFILending', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  submitPfiLendingAccount: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/ExternalLoanAccount/v1/Submit', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPfiLoanAccountsList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/ExternalLoanAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPfiLoanAccount: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/accounting/api/ExternalLoanAccount/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCreditLimits: async (context, { partnerCode, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/PartnerCreditLimit/v1/View?PartnerCode=${partnerCode}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCreditLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerCreditLimit/v1/SaveOrUpdate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  uploadMFADocument: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/UploadOrUpdatePartnerDocument', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getMasterFinancingAgreement: async (context, { partnerCode, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/PartnerFinancialInstitution/v1/GetPartnerDocuments?PartnerCode=${partnerCode}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  saveReviewerComment: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.patch('/accounting/api/PartnerFinancialInstitutionDueDiligence/v1/UpdateReviewerComment', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getReviewComments: async (context, { partnerCode, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/PartnerFinancialInstitutionDueDiligence/v1/GetAllReviewerComments?partnerCode=${partnerCode}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateLoanAmount: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/ExternalLoanAccount/v1/ValidateLoanAmount', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  ScheduleSimulation: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/ExternalLoanAccount/v1/ScheduleSimulation', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  deleteMFADocumentsUploadAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/PartnerFinancialInstitution/v1/DeletePartnerDocument', { documentId: formData.documentId })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  uploadImageFileAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/DocumentManagement/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  createSavingsPocketAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/Savings/v1/Savings/Create', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateSavingsPocketAccounts: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/accounting/api/Savings/v1/Savings/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateSavingsPocketStatus: async (context, {
    routeName, id, statusType, permission,
  }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/accounting/api/Savings/v1/${routeName}/UpdateStatus?id=${id}&Status=${statusType}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  flexibleTopupAccounts: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/Savings/v1/FlexSave/Topup', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getSavingsPocketAction: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/Savings/v1/Savings/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLiquidationAccountDetail: async (context, { id, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`accounting/api/Savings/v1/${routeName}/Get?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performLiquidationAction: async (context, { formData, routePath, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(`/accounting/api/Savings/v1/${routePath}`, formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createQuestionsAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/Chat/v1/Ask', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
